<template>
  <router-view @triggerPopup="finalLanding"/>
</template>
 
<script>
export default {
  name: 'App',
  setup(){
    const finalLanding= () =>{
      console.log('submiting')
    }

    return {finalLanding}
  }
}
</script>

<style lang="scss">
@import url('./sass/main.scss');
body{
  overflow-x:hidden;
}
@import url('./sass/responsive.scss');
</style>
